export class WorkerUrlExtractor {
  public url: string | URL

  constructor(url: string | URL) {
    this.url = url
  }
}
